import React from 'react';

const About: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto">
      <div className="mb-8">
        <h1 className="text-4xl font-bold text-gray-800 mb-4">About DDQ Frontend</h1>
        <p className="text-lg text-gray-600 leading-relaxed">
          This is a modern React TypeScript application built with best practices and a beautiful design system.
        </p>
      </div>
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <section className="card-elevated">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Technology Stack</h2>
          <ul className="space-y-3">
            <li className="flex items-center">
              <div className="w-2 h-2 bg-adalabs-blue-500 rounded-full mr-3"></div>
              <span><strong>React 18</strong> - UI library</span>
            </li>
            <li className="flex items-center">
              <div className="w-2 h-2 bg-adalabs-blue-500 rounded-full mr-3"></div>
              <span><strong>TypeScript</strong> - Type safety</span>
            </li>
            <li className="flex items-center">
              <div className="w-2 h-2 bg-adalabs-blue-500 rounded-full mr-3"></div>
              <span><strong>React Router</strong> - Navigation</span>
            </li>
            <li className="flex items-center">
              <div className="w-2 h-2 bg-adalabs-blue-500 rounded-full mr-3"></div>
              <span><strong>Axios</strong> - HTTP client</span>
            </li>
            <li className="flex items-center">
              <div className="w-2 h-2 bg-adalabs-blue-500 rounded-full mr-3"></div>
              <span><strong>Tailwind CSS</strong> - Styling framework</span>
            </li>
          </ul>
        </section>

        <section className="card-elevated">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Project Structure</h2>
          <div className="bg-gray-50 rounded-lg p-4 font-mono text-sm">
            <pre className="whitespace-pre-wrap text-gray-700">
{`src/
├── components/     # Reusable UI components
├── pages/         # Page components
├── hooks/         # Custom React hooks
├── utils/         # Utility functions
├── services/      # API services
├── types/         # TypeScript type definitions
└── assets/        # Static assets`}
            </pre>
          </div>
        </section>
      </div>

      <div className="mt-8 card-elevated">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Features</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="text-center">
            <div className="w-12 h-12 bg-adalabs-blue-100 rounded-lg flex items-center justify-center mx-auto mb-3">
              <span className="text-adalabs-blue-600 text-xl">⚡</span>
            </div>
            <h3 className="font-semibold text-gray-800 mb-2">Fast & Responsive</h3>
            <p className="text-gray-600 text-sm">Built with modern React patterns for optimal performance</p>
          </div>
          <div className="text-center">
            <div className="w-12 h-12 bg-adalabs-green-100 rounded-lg flex items-center justify-center mx-auto mb-3">
              <span className="text-adalabs-green-600 text-xl">🎨</span>
            </div>
            <h3 className="font-semibold text-gray-800 mb-2">Beautiful Design</h3>
            <p className="text-gray-600 text-sm">Modern UI with consistent design system</p>
          </div>
          <div className="text-center">
            <div className="w-12 h-12 bg-adalabs-maroon-600 rounded-lg flex items-center justify-center mx-auto mb-3">
              <span className="text-white text-xl">🔧</span>
            </div>
            <h3 className="font-semibold text-gray-800 mb-2">Type Safe</h3>
            <p className="text-gray-600 text-sm">Full TypeScript support for better development experience</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About; 